import { CheckRow } from '@workspace/ui/components/check-row'
import { ShareUrlLabel } from '../../../../lib/share-url-label'

export interface ShareLinkVisualProps {
  /** The startup's default share-link URL, or null while it is still loading. */
  url: string | null
  /** Whether the link was just copied — shared with the primary "Copy your
   *  link" button below the card, so both read "Copied" together. */
  copied: boolean
  onCopy: () => void
}

/**
 * QUEST_SHARE's visual: the real link with its own copy button, plus the
 * three reassurances from the prototype's checklist. Passed as `visualOverride`
 * from home-page.tsx (same pattern as the deck dropzone on QUEST_UPLOAD_DECK)
 * because it needs the fetched share-link URL, which is not part of the
 * home-state payload.
 */
export function ShareLinkVisual({ url, copied, onCopy }: ShareLinkVisualProps) {
  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-wrap items-center gap-2 rounded-lg border border-border bg-card px-3.5 py-2.5 text-[14px]">
        {url ? (
          <ShareUrlLabel url={url} className="truncate" />
        ) : (
          <span className="truncate text-muted-foreground">Preparing your link…</span>
        )}
        <button
          type="button"
          onClick={onCopy}
          disabled={!url}
          className="ml-auto rounded-md bg-primary px-3 py-1.5 text-[12.5px] font-bold text-primary-foreground disabled:opacity-50"
        >
          {copied ? 'Copied' : 'Copy'}
        </button>
      </div>
      <div>
        <CheckRow tone="ok">
          Always shows your latest profile, so every investor sees the current version
        </CheckRow>
        <CheckRow tone="ok">You get an email the moment an investor opens it</CheckRow>
        <CheckRow tone="ok">Investors need no account to read it</CheckRow>
      </div>
    </div>
  )
}
